// Shared money formatting for the theme scripts: window.theme.formatMoney(cents, format) fills the shop's money format
// ({{ shop.money_format }}, passed by each block as data-money-format) with the amount in its separator style.
// The result is plain text (scripts write it with textContent), so HTML in the money format is left out.
// Theme settings > Currency format > "Show cents only when a price has them" (data-smart-cents on this script, set in
// layout/theme.liquid): round prices without ,00 and prices with cents with them, whatever the format says; the same
// rule as snippets/money-text.liquid.
(() => {
  window.theme = window.theme || {};
  if (window.theme.formatMoney) return;
  const smartCents = document.currentScript?.dataset.smartCents === 'true';

  window.theme.formatMoney = (cents, format = '{{amount}}') => {
    format = String(format).replace(/<[^>]*>/g, '');
    const amount = Math.round(Number(cents) || 0);
    const value = amount / 100;
    const pattern = /\{\{\s*(\w+)\s*\}\}/;
    const kind = (format.match(pattern) || [])[1] || 'amount';
    const group = (number, decimals, thousands, decimal) => {
      const [whole, fraction] = number.toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
    };
    // [thousands, decimal, decimals] of each Shopify amount placeholder
    const [thousands, decimal, decimals] = {
      amount: [',', '.', 2],
      amount_no_decimals: [',', '.', 0],
      amount_with_comma_separator: ['.', ',', 2],
      amount_no_decimals_with_comma_separator: ['.', ',', 0],
      amount_with_apostrophe_separator: ["'", '.', 2],
      amount_with_space_separator: [' ', ',', 2],
      amount_no_decimals_with_space_separator: [' ', ',', 0],
      amount_with_period_and_space_separator: [' ', '.', 2],
    }[kind] || [',', '.', 2];
    const shown = smartCents ? (Math.abs(amount) % 100 === 0 ? 0 : 2) : decimals;
    return format.replace(pattern, group(value, shown, thousands, decimal));
  };
})();
